import { useEffect } from 'react';
import LocalStorageType from '../../constants/LocalStorageType';
import './ChatwootWidget.css';

const BASE_URL = 'https://hub.colmeiabarber.com';

// Montado apenas no ramo autenticado do App.
export default function ChatwootWidget() {
  useEffect(() => {
    let active = true;
    let script;
    document.body.setAttribute('data-chatwoot-authenticated', 'true');

    const syncLoggedUser = () => {
      if (!window.$chatwoot?.setUser) return;

      try {
        const loggedUser = JSON.parse(localStorage.getItem(LocalStorageType.USER_DETAILS) || '{}');
        if (!loggedUser.id) return;

        const customAttributes = {};
        if (loggedUser.companyName) {
          customAttributes.company_name = loggedUser.companyName;
        }

        // O nome da empresa vai como atributo do contato para não substituir o nome
        // do usuário, que continua sendo a identificação principal no Chatwoot.
        window.$chatwoot.setUser(String(loggedUser.id), {
          name: loggedUser.fullName || [loggedUser.firstName, loggedUser.lastName].filter(Boolean).join(' '),
          email: loggedUser.email,
          custom_attributes: customAttributes,
        });
      } catch (error) {
        // Um localStorage inválido não deve impedir a abertura do atendimento.
      }
    };

    const showWidget = () => {
      if (!active) return;
      syncLoggedUser();
      window.$chatwoot?.toggleBubbleVisibility('show');
    };

    const initialize = () => {
      if (!active) return;
      if (window.$chatwoot) {
        showWidget();
      } else {
        window.chatwootSDK.run({
          websiteToken: 'fZeigL87wcxKu72ExhKS1dn4',
          baseUrl: BASE_URL,
        });
      }
    };

    window.addEventListener('chatwoot:ready', showWidget);
    if (window.chatwootSDK) {
      initialize();
    } else {
      script = document.createElement('script');
      script.src = `${BASE_URL}/packs/js/sdk.js`;
      script.async = true;
      script.onload = initialize;
      document.head.appendChild(script);
    }

    return () => {
      active = false;
      document.body.removeAttribute('data-chatwoot-authenticated');
      window.removeEventListener('chatwoot:ready', showWidget);
      if (script) {
        script.onload = null;
        script.remove();
      }
      if (window.$chatwoot) {
        window.$chatwoot.toggle('close');
        window.$chatwoot.toggleBubbleVisibility('hide');
        window.$chatwoot.reset();
      }
    };
  }, []);

  return null;
}
